export default theme => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  materialIcon: {
    paddingLeft: '5px',
    marginBottom: '-3px',
    width: '24px',
    height: '24px',
  }
});
